import { PbxPreview } from './pbx'
import { VoicemailStatus } from './voicemail'

export enum ExtensionType {
  LINE = 'ExtensionLine',
  SHARED = 'ExtensionSharedVoicemailBox',
  DIAL_PLAN = 'ExtensionDialPlan',
  CALL_QUEUE = 'ExtensionCallQueue',
  RING_GROUP = 'ExtensionRingGroup',
  VIRTUAL_FAX = 'ExtensionVirtualFaxMachine',
  CONFERENCE_ROOM = 'ExtensionConferenceRoom',
}
// Ref: https://api.mangovoice.com/extensions/select/
export interface ExtensionPreview {
  id: number
  uuid: string
  name: string
  number: string
  type: ExtensionType
  pbx_id: number
}

export interface Extension extends Omit<ExtensionPreview, 'pbx_id'> {
  uuid: string
  pbx: PbxPreview
  voicemail_status?: VoicemailStatus
  created_at: string
  updated_at: string
  voicemail_enabled: number | null
}

export interface ExtensionInstance {
  id: number
  uuid: string
  type: ExtensionType
  name: string
  number: string
  pbx: PbxPreview
  voicemail_status?: VoicemailStatus
  created_at: string
  updated_at: string
  voicemail_enabled: number | null
  resendable_secure_fax_count?: number | null
  /**
   * Active state. The /extensions/ serializer returns a Django boolean
   * (`true`/`false`); some legacy/internal payloads still surface a
   * numeric 0/1 flag. Optional because not every endpoint that returns
   * an `ExtensionInstance` includes it.
   */
  active?: boolean | number | null
  /** Legacy alias for `active`; still present in some internal payloads. */
  is_active?: number | boolean | null
}
